const styles = theme => ({
  button: {
    backgroundColor: 'white',
    fontSize: 14,
    padding: '5px 15px',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    borderRadius: 15,
    textTransform: 'none',
    lineHeight: '1em',
    marginRight: 5,
    '&:last-of-type': {
      marginRight: 0
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    },
    '&:disabled': {
      color: 'lightgrey',
      borderColor: 'lightgrey'
    },
    [theme.breakpoints.only("xs")]: {
      marginBottom: 5,
    }
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:before': {
      content: "''",
      display: 'block',
      width: 12,
      height: 7,
      border: '2px solid white',
      borderTop: 'none',
      borderRight: 'none',
      transform: 'rotate(-45deg)',
      marginRight: 5,
      marginTop: -4
    },
    '&:disabled': {
      color: 'white',
      backgroundColor: 'lightgrey',
    }
  },
  wrapper: {
    display: 'inline-block'
  }
})

export default styles;